export type Role = "host" | "remote" | "display";

const CLIENT_ROLE: Record<string, Role> = {
  HOST: "host",
  REMOTE: "remote",
  DISPLAY: "display",
};

let role: Role | undefined;
let mountPoint: string;
let classId: string | null;
let roleSlice: string | undefined;
// try parsing with new scheme first
// path looks like "/apps/remote/mobile/52336bbeb74a7a0000000011" or "/apps/display"
// server side won't have window.location
const roleValues = new Set(Object.values(CLIENT_ROLE));
const isRoleType = (val: string): val is Role => roleValues.has(val);
if (typeof window !== "undefined") {
  const basePath = (Config.prSubpath || "/").replace(/\/$/, "");
  const rawPath = window.location.pathname;
  const path = basePath && rawPath.startsWith(basePath) ? rawPath.slice(basePath.length) : rawPath;
  [roleSlice, mountPoint, classId] = path.split("/").slice(2);
  role = roleSlice && isRoleType(roleSlice) ? roleSlice : undefined;
  // try old scheme
  if (!role && path.startsWith("/apps")) {
    const params = new URLSearchParams(window.location.search);
    role = params.get("role") === "display" ? CLIENT_ROLE.DISPLAY : CLIENT_ROLE.REMOTE;
    mountPoint = params.get("modal") === "true" ? "teach" : "mobile";
    classId = params.get("classId");
  }
}

const isDisplay = role === CLIENT_ROLE.DISPLAY;
const isRemote = role === CLIENT_ROLE.REMOTE;
export { role, isDisplay, isRemote, mountPoint, classId };
